<template>
  <span class="quoteActionsButtonWrapper">
    <app-button
      data-qa="send-sales-order-button"
      class="quoteActionsButton"
      @click="toggleSendToAutolineModal(true)"
    >
      {{ i18n.t('/QuoteActions/SendToAutolineButton') }}
    </app-button>

    <div v-if="!loading">
      <confirmation-prompt
        id="send-to-autoline-prompt"
        :show="showSendToAutolinePrompt"
        :title="popupTitle"
        :info-text="popupText"
        :extra-wide="true"
        :cancel-button-show="!expectedDeliveryDateUnknownAndForced"
        :confirm-button-show="!expectedDeliveryDateUnknownAndForced"
        @confirm="requestSendToAutoline"
        @cancel="toggleSendToAutolineModal(false)"
        @close="toggleSendToAutolineModal(false)"
      >
      </confirmation-prompt>
    </div>
    <div v-else>
      <modal :title="i18n.t('/QuoteActions/Forms/SendToAutoline/Title')">
        <loader />
      </modal>
    </div>
  </span>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapState } from 'vuex'
import AdditionalOrder from '@/mixins/additionalOrder.js'
import CheckExpectedDeliveryDate from '@/mixins/checkExpectedDeliveryDate'
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import quoteOrderService from '@/services/quoteOrderService.js'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'

export default {
  components: {
    AppButton,
    ConfirmationPrompt,
    Modal,
    Loader,
  },
  mixins: [AdditionalOrder, CheckExpectedDeliveryDate],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showSendToAutolinePrompt: false,
      loading: false,
    }
  },
  computed: {
    ...mapState({
      quote(state, getters) {
        return getters[this.quoteNamespace + '/get']
      },
    }),
    quoteId() {
      return this.quote.QuoteId
    },
    popupTitle() {
      return this.expectedDeliveryDateUnknownAndForced
        ? this.i18n.t('/expected delivery date/error/title')
        : this.i18n.t('/QuoteActions/Forms/SendToAutoline/Title')
    },
    popupText() {
      return this.expectedDeliveryDateUnknownAndForced
        ? this.i18n.t('/expected delivery date/error/text')
        : this.i18n.t('/QuoteActions/Forms/SendToAutoline/Text')
    },
  },
  methods: {
    toggleSendToAutolineModal(show) {
      this.showSendToAutolinePrompt = show
    },
    async requestSendToAutoline() {
      this.loading = true

      let salesOrderParams = {
        quoteId: this.quoteId,
        sendEmailToCustomer: false,
        sendCopyToEmployee: false,
        digitalSigningParams: null,
        sendSigning: false,
        reserveInIds: false,
        isApprovalRequest: false,
      }

      // first updateQuote, then request Salesorder
      this.requestSalesOrderResult = await quoteOrderService.requestSalesOrder(salesOrderParams)

      this.hasErrors =
        this.requestSalesOrderResult.salesOrderHasErrors ||
        this.requestSalesOrderResult.quoteHasErrors

      this.loading = false
      this.requestedSalesOrder = true
    },
  },
}
</script>

<style lang="scss" scoped>
.quoteActionsButton {
  margin-bottom: 0;
}
</style>
